// Se reemplaza por LmCommonProps.js
// Se depreca al migrar todos los componentes de formbuilder a este mixin
import LmDropdown from '@/components/LmDropdown'

export default {
  inject: {
    context: {
      type: Object,
      default: null
    },
    isOnPreviewMode: {
      type: Boolean,
      default: false
    },
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    document: {
      type: Object,
      default: null
    }
  },
  components: {
    LmDropdown
  },
  computed: {
    id () {
      return this.$attrs?.id || ''
    },
    idComputed () {
      return this.$attrs?.id || this.label || ''
    },
    isOnModeLabelOnLeft () {
      return this.mode === 'labelOnLeft'
    },
    titleComputed () {
      return this.labelTitle || this.label || ''
    },
    required () {
      return this.v.required !== undefined
    },
    minLengthCharactersRequired () {
      return this.v.$params.minLength ? this.v.$params.minLength.min : null
    },
    maxLengthCharactersAllowed () {
      return this.v.$params.maxLength ? this.v.$params.maxLength.max : null
    },
    exactLengthRequired () {
      return this.v.$params.exactLength ? this.v.$params.exactLength.exact : null
    },
    wasMaxLengthReached () {
      return this.maxLength === this.value?.length
    },

    // Validaciones nuevas

    validation () {
      if (!Object.keys(this.v).length) {
        return { hasError: false }
      }
      return {
        hasError: '$error' in this.v ? this.v.$error : undefined,
        required: 'required' in this.v ? this.v.required : undefined,
        maxLength: 'maxLength' in this.v ? this.v.maxLength : undefined,
        minLength: 'minLength' in this.v ? this.v.minLength : undefined,
        sameAs: 'sameAs' in this.v ? this.v.sameAs : undefined
      }
    },

    showValidationErrorMessage () {
      if (this.validation.required === false) {
        return this.$t('field_required')
      }
      if (this.validation.maxLength === false) {
        return this.$tc('character_max_length', this.v.$params.maxLength.max)
      }
      if (this.validation.minLength === false) {
        return this.$tc('character_min_length', this.v.$params.minLength.min)
      }
      if (this.validation.sameAs === false) {
        return this.$t('field_same_as') + this.labelOfFieldUsedForsameAsValidation
      }
      return null
    },

    showComponent () {
      if (this.visibility?.isActive && this.visibility?.conditions?.length && this.context) {
        let show = true
        for (const condition of this.visibility.conditions) {
          show = this.processCondition(this.context[condition.leftValueToCompare], condition.comparation, condition.rightValueToCompare)
          if (!show) break
        }
        return show
      }
      return true
    },

    disableEditors () {
      if (this.document === null) {
        return true
      }
      return this.document.isStarted
    },

    collaborator () {
      if (!Object.keys(this.editor).length && this.isEditableByPickedUser) {
        const currentUser = this.$store.getters['session/userInfo']
        return {
          id: currentUser.id,
          name: `${currentUser.firstname} ${currentUser.lastname}`,
          action: 'E'
        }
      }
      return this.editor
    },

    isEditableByMe () {
      if (Object.keys(this.collaborator).length && this.isEditableByPickedUser) {
        const currentUser = this.$store.getters['session/userInfo']
        return currentUser.id === this.collaborator.id
      }
      return true
    }
  },
  watch: {
    // Si el componente deja de mostrarse, su valor vuelve a "null"
    // Guardo su valor en un backup por si se vuelve a mostrar
    showComponent (val) {
      if (!val) {
        this.valueBackup = this.value
        this.$emit('input', null)
      } else {
        if (this.valueBackup) {
          this.$emit('input', this.valueBackup)
        }
      }
      this.$emit('regenerate-validations')
    }
  },
  props: {
    visibility: {
      type: Object,
      default: null
    },
    isVisible: {
      type: Boolean,
      default: true
    },
    showEditButton: {
      type: Boolean,
      default: false
    },
    help: {
      type: String,
      default: ''
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    labelTitle: {
      type: String,
      default: ''
    },
    /**
    * Setea la posición del label. Las opciones disponibles son: "labelOnTop", "labelOnLeft"
    */
    mode: {
      type: String,
      default: 'labelOnTop'
    },
    placeholder: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    /**
    * Al ser seteado agrega un label al input y automática agrega in id al mismo para poder vincular el click sobre el label con el foco en el input.
    */
    label: {
      type: String,
      default: ''
    },
    v: {
      type: Object,
      default: () => ({})
    },
    /**
    * Disabled input
    */
    disabled: {
      type: Boolean,
      default: false
    },
    validateOnfocusOut: {
      type: Boolean,
      default: true
    },
    value: null,
    labelOfFieldUsedForsameAsValidation: {
      type: String,
      default: ''
    },
    isEditableByPickedUser: {
      type: Boolean,
      default: false
    },
    editor: {
      type: Object,
      default: () => ({})
    },
    modelName: {
      type: String,
      default: null
    },
    tabindex: {
      type: [Number, null],
      default: null
    }
  },
  methods: {
    validateOnfocusOutMethod () {
      if (this.v.$touch && this.validateOnfocusOut) {
        this.v.$touch()
      }
    },

    processCondition (leftVal, comparation, rightVal) {
      let show
      if (typeof leftVal === 'boolean') {
        leftVal = String(leftVal)
      }
      if (typeof rightVal === 'boolean') {
        leftVal = String(leftVal)
      }
      leftVal = leftVal?.id || leftVal?.name || leftVal
      rightVal = rightVal?.id || rightVal?.name || rightVal
      switch (comparation) {
        case '===':
          show = leftVal === rightVal
          break
        case '!==':
          show = leftVal !== rightVal
          break
        case '>':
          show = leftVal > rightVal
          break
        case '>=':
          show = leftVal >= rightVal
          break
        case '<':
          show = leftVal < rightVal
          break
        case '<=':
          show = leftVal <= rightVal
          break
      }
      return show
    }
  }
}
